import { useState } from 'react';
import Button from '../../../../components/Button/Button';
import FormHeading from '../../../../components/Typography/FormHeading';
import { DEAL_STEPS } from '../../../../constants';
import CarDelivery from '../CommonBankSteps/CarDelivery';
import LoaderInline from '../../../../components/Loader/LoaderInline';
import ContractSign from '../CommonBankSteps/ContractSign';
import StepControlButtons from '../CommonBankSteps/StepControlButtons';

const BerekeFlow = ({ step, deal, goBack, update, documents, cars }) => {
  const [loading, setLoading] = useState(false);

  if (loading) {
    return <LoaderInline />;
  }

  if (step === DEAL_STEPS.BEREKE.SIGN_CONTRACT) {
    return (
      <ContractSign
        deal={deal}
        documents={documents}
        cars={cars}
        dealStepAfterSign={DEAL_STEPS.BEREKE.WAITING_FOR_CLIENT_ACTIONS}
        setLoading={setLoading}
        update={update}
      />
    );
  }

  if (step === DEAL_STEPS.BEREKE.WAITING_FOR_CLIENT_ACTIONS) {
    return (
      <>
        <FormHeading>Ð¡ÑÐ°ÑÑÑ</FormHeading>
        <Button
          text={'ÐÐ»Ð¸ÐµÐ½ÑÑ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¾Ð±ÑÐ°ÑÐ¸ÑÑÑÑ Ð² Ð±Ð°Ð½Ðº Ð´Ð»Ñ Ð´Ð°Ð»ÑÐ½ÐµÐ¹ÑÐµÐ³Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ'}
          style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)' }}
        />
      </>
    );
  }
  if (step === DEAL_STEPS.BEREKE.CAR_DELIVERY) {
    <>
      <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.BEREKE.WAITING_FOR_CLIENT_ACTIONS}
          update={update}
          setLoading={setLoading}
      />
      <CarDelivery deal={deal} loading={loading} setLoading={setLoading} onSuccess={update} />;
    </>;
  }
};

export default BerekeFlow;
